module.exports = __webpack_public_path__ + "static/media/Tang Pual Quek.c99efda5.png";